"use client";

import { REUSE_CSS } from "@/app/v3/shared";
import { ShowcaseRowV3, type ShowcaseConfig } from "@/app/v3/ShowcaseRowV3";
import type { BlogPost } from "@/lib/blog";

/**
 * The homepage's Watch it / Ask it / Hear it row, driven by a note. Same
 * component, same CSS (REUSE_CSS is scoped to .v3reuse), no Call it door.
 * The .kblog root already defines the --serif-memo / --mono variables the
 * row's CSS reads.
 */
export function NoteShowcase({ post }: { post: BlogPost }) {
  if (!post.videoUrl) return null;

  const config: ShowcaseConfig = {
    video: {
      src: post.videoUrl,
      poster: post.posterUrl ?? "",
      kicker: `This note${post.videoDuration ? ` · ${post.videoDuration}` : ""}`,
      caption: `${post.title} · generated by Kreayt`,
      ariaLabel: `Play ${post.title}`,
    },
    ask: {
      runId: post.askRunId ?? "",
      title: post.title,
      topic: post.description,
      chips: post.askChips ?? [],
      emptyCopy:
        "Ask anything the video covers. Every answer comes from the cited sources behind it, not from a model’s memory.",
      placeholder: "Ask this note a question…",
      noteSlug: post.slug,
    },
    hear: {
      src: post.audioUrl ?? "",
      peaks: post.audioPeaks ?? [],
      title: `${post.title} — the audio edition`,
      kicker: `Same note · for the commute${post.videoDuration ? ` · ${post.videoDuration}` : ""}`,
      line: "Every note ships as an audio edition.",
    },
    phone: false,
    track: { slug: post.slug, title: post.title },
  };

  return (
    <div className="v3reuse rowwrap">
      <style>{REUSE_CSS}</style>
      <ShowcaseRowV3 config={config} />
    </div>
  );
}
